module.exports = __webpack_public_path__ + "img/timesheet-log-book_B09NH3CTNT.314de3c9.jpg";